import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getCreditHisotry = (params) => {
    return axios.get(`${backendHost}/api/admin/history-replenishment/list`, {params});
};

export {
    getCreditHisotry
}